module.exports = __webpack_public_path__ + "img/hio-logo.6bd3ee10.svg";